import { ChainId } from '@donaswap/sdk'

export const GRAPH_API_PROFILE = 'https://api.thegraph.com/subgraphs/name/pancakeswap/profile'
export const GRAPH_API_PREDICTION_BNB = 'https://api.thegraph.com/subgraphs/name/pancakeswap/prediction-v2'
export const GRAPH_API_PREDICTION_FLAME = 'https://api.thegraph.com/subgraphs/name/pancakeswap/prediction-cake'

export const GRAPH_API_LOTTERY = 'https://api.thegraph.com/subgraphs/name/pancakeswap/lottery'
export const SNAPSHOT_BASE_URL = process.env.NEXT_PUBLIC_SNAPSHOT_BASE_URL
export const API_PROFILE = 'https://profile.pancakeswap.com'
export const API_NFT = 'https://nft.pancakeswap.com/api/v1'
export const SNAPSHOT_API = `${SNAPSHOT_BASE_URL}/graphql`
export const SNAPSHOT_HUB_API = `${SNAPSHOT_BASE_URL}/api/message`
export const GRAPH_API_POTTERY = 'https://api.thegraph.com/subgraphs/name/pancakeswap/pottery'
export const ONRAMP_API_BASE_URL = 'https://pcs-onramp-api.com'
export const MOONPAY_BASE_URL = 'https://api.moonpay.com'
export const MOONPAY_SIGN_URL = 'https://pcs-on-ramp-api.com'
/**
 * V1 will be deprecated but is still used to claim old rounds
 */
export const GRAPH_API_PREDICTION_V1 = 'https://api.thegraph.com/subgraphs/name/pancakeswap/prediction'

export const INFO_CLIENT = 'https://proxy-worker.pancake-swap.workers.dev/bsc-exchange'
export const INFO_CLIENT_FIRE = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const INFO_CLIENT_ETH = 'https://api.thegraph.com/subgraphs/name/pancakeswap/exhange-eth'
export const INFO_CLIENT_MATIC = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const INFO_CLIENT_CRO = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const INFO_CLIENT_AVAX = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const INFO_CLIENT_FTM = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const INFO_CLIENT_CELO = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const INFO_CLIENT_OP_ETH = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const INFO_CLIENT_ARBI_ETH = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const INFO_CLIENT_BONE = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const INFO_CLIENT_PLS = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const INFO_CLIENT_XN = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const INFO_CLIENT_ONE = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const INFO_CLIENT_CET = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const INFO_CLIENT_DOGE = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const INFO_CLIENT_ETC = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const INFO_CLIENT_FSN = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const INFO_CLIENT_HECO = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const INFO_CLIENT_KCS = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const INFO_CLIENT_KLAY = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const INFO_CLIENT_OKT = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const INFO_CLIENT_TFUEL = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const INFO_CLIENT_ULX = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const INFO_CLIENT_GLMR = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const INFO_CLIENT_MOVR = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const INFO_CLIENT_AURORA_ETH = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const INFO_CLIENT_BOBA_ETH = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const INFO_CLIENT_XDAI = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const INFO_CLIENT_METIS = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const INFO_CLIENT_TLOS = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const INFO_CLIENT_SYS = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const INFO_CLIENT_IOTX = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const INFO_CLIENT_SDN = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const INFO_CLIENT_ASTR = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const INFO_CLIENT_SBY = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const INFO_CLIENT_FUSE = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const INFO_CLIENT_VLX = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const INFO_CLIENT_REI = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const INFO_CLIENT_KEK = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const INFO_CLIENT_TOMO = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const INFO_CLIENT_TT = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const INFO_CLIENT_WAN = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const INFO_CLIENT_RBTC = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const INFO_CLIENT_ELA = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const INFO_CLIENT_CFX = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const INFO_CLIENT_BRISE = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const INFO_CLIENT_MUU = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const INFO_CLIENT_CANTO = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const INFO_CLIENT_ROSE = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const INFO_CLIENT_VS = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const INFO_CLIENT_STEP = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const INFO_CLIENT_MTR = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const INFO_CLIENT_PCKB = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const INFO_CLIENT_CLO = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const INFO_CLIENT_EVMOS = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const INFO_CLIENT_EWT = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const INFO_CLIENT_BASE_ETH = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const INFO_CLIENT_KAVA = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const INFO_CLIENT_CLOVER = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const INFO_CLIENT_DEFICHAIN = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const INFO_CLIENT_BRONOS = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const INFO_CLIENT_FILECOIN = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const INFO_CLIENT_FLARE = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const INFO_CLIENT_TARAXA = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const INFO_CLIENT_ZKSYNC = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const INFO_CLIENT_LINEA = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const INFO_CLIENT_BTTCHAIN = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const INFO_CLIENT_BOBA_AVAX = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const INFO_CLIENT_BOBA_BNB = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const INFO_CLIENT_CMP = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const INFO_CLIENT_CORE = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const INFO_CLIENT_CUBECHAIN = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const INFO_CLIENT_DARWINIA_CRAB = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const INFO_CLIENT_DIODE_PRETNET = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const INFO_CLIENT_GOCHAIN = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const INFO_CLIENT_HAQQ = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const INFO_CLIENT_KARDIACHAIN = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const INFO_CLIENT_METADIUM = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const INFO_CLIENT_PALM = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const INFO_CLIENT_POLIS = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const INFO_CLIENT_SHIBACHAIN = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const INFO_CLIENT_SMART_BCH = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const INFO_CLIENT_SONGBIRD_CANARY = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const INFO_CLIENT_THAICHAIN = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const INFO_CLIENT_UBIQ = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const INFO_CLIENT_VECHAIN = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const INFO_CLIENT_XINFIN = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const INFO_CLIENT_SCROLL = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const INFO_CLIENT_ZYX = 'https://api.thegraph.com/subgraphs/name/donaswap/'

export const V3_BSC_INFO_CLIENT = `https://open-platform.nodereal.io/${
  process.env.NEXT_PUBLIC_NODE_REAL_API_INFO || process.env.NEXT_PUBLIC_NODE_REAL_API_ETH
}/pancakeswap-v3/graphql`

export const BLOCKS_CLIENT = 'https://api.thegraph.com/subgraphs/name/pancakeswap/blocks'
export const BLOCKS_CLIENT_FIRE = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const BLOCKS_CLIENT_ETH = 'https://api.thegraph.com/subgraphs/name/blocklytics/ethereum-blocks'
export const BLOCKS_CLIENT_MATIC = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const BLOCKS_CLIENT_CRO = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const BLOCKS_CLIENT_AVAX = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const BLOCKS_CLIENT_FTM = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const BLOCKS_CLIENT_CELO = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const BLOCKS_CLIENT_OP_ETH = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const BLOCKS_CLIENT_ARBI_ETH = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const BLOCKS_CLIENT_BONE = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const BLOCKS_CLIENT_PLS = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const BLOCKS_CLIENT_XN = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const BLOCKS_CLIENT_ONE = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const BLOCKS_CLIENT_CET = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const BLOCKS_CLIENT_DOGE = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const BLOCKS_CLIENT_ETC = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const BLOCKS_CLIENT_FSN = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const BLOCKS_CLIENT_HECO = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const BLOCKS_CLIENT_KCS = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const BLOCKS_CLIENT_KLAY = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const BLOCKS_CLIENT_OKT = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const BLOCKS_CLIENT_TFUEL = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const BLOCKS_CLIENT_ULX = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const BLOCKS_CLIENT_GLMR = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const BLOCKS_CLIENT_MOVR = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const BLOCKS_CLIENT_AURORA_ETH = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const BLOCKS_CLIENT_BOBA_ETH = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const BLOCKS_CLIENT_XDAI = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const BLOCKS_CLIENT_METIS = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const BLOCKS_CLIENT_TLOS = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const BLOCKS_CLIENT_SYS = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const BLOCKS_CLIENT_IOTX = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const BLOCKS_CLIENT_SDN = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const BLOCKS_CLIENT_ASTR = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const BLOCKS_CLIENT_SBY = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const BLOCKS_CLIENT_FUSE = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const BLOCKS_CLIENT_VLX = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const BLOCKS_CLIENT_REI = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const BLOCKS_CLIENT_KEK = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const BLOCKS_CLIENT_TOMO = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const BLOCKS_CLIENT_TT = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const BLOCKS_CLIENT_WAN = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const BLOCKS_CLIENT_RBTC = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const BLOCKS_CLIENT_ELA = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const BLOCKS_CLIENT_CFX = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const BLOCKS_CLIENT_BRISE = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const BLOCKS_CLIENT_MUU = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const BLOCKS_CLIENT_CANTO = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const BLOCKS_CLIENT_ROSE = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const BLOCKS_CLIENT_VS = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const BLOCKS_CLIENT_STEP = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const BLOCKS_CLIENT_MTR = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const BLOCKS_CLIENT_PCKB = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const BLOCKS_CLIENT_CLO = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const BLOCKS_CLIENT_EVMOS = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const BLOCKS_CLIENT_EWT = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const BLOCKS_CLIENT_BASE_ETH = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const BLOCKS_CLIENT_KAVA = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const BLOCKS_CLIENT_CLOVER = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const BLOCKS_CLIENT_DEFICHAIN = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const BLOCKS_CLIENT_BRONOS = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const BLOCKS_CLIENT_FILECOIN = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const BLOCKS_CLIENT_FLARE = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const BLOCKS_CLIENT_TARAXA = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const BLOCKS_CLIENT_ZKSYNC = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const BLOCKS_CLIENT_LINEA = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const BLOCKS_CLIENT_BTTCHAIN = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const BLOCKS_CLIENT_BOBA_AVAX = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const BLOCKS_CLIENT_BOBA_BNB = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const BLOCKS_CLIENT_CMP = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const BLOCKS_CLIENT_CORE = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const BLOCKS_CLIENT_CUBECHAIN = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const BLOCKS_CLIENT_DARWINIA_CRAB = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const BLOCKS_CLIENT_DIODE_PRETNET = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const BLOCKS_CLIENT_GOCHAIN = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const BLOCKS_CLIENT_HAQQ = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const BLOCKS_CLIENT_KARDIACHAIN = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const BLOCKS_CLIENT_METADIUM = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const BLOCKS_CLIENT_PALM = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const BLOCKS_CLIENT_POLIS = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const BLOCKS_CLIENT_SHIBACHAIN = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const BLOCKS_CLIENT_SMART_BCH = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const BLOCKS_CLIENT_SONGBIRD_CANARY = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const BLOCKS_CLIENT_THAICHAIN = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const BLOCKS_CLIENT_UBIQ = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const BLOCKS_CLIENT_VECHAIN = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const BLOCKS_CLIENT_XINFIN = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const BLOCKS_CLIENT_SCROLL = 'https://api.thegraph.com/subgraphs/name/donaswap/'
export const BLOCKS_CLIENT_ZYX = 'https://api.thegraph.com/subgraphs/name/donaswap/'

export const STABLESWAP_SUBGRAPH_CLIENT = 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-stableswap'
export const GRAPH_API_NFTMARKET = 'https://api.thegraph.com/subgraphs/name/pancakeswap/nft-market'
export const GRAPH_HEALTH = 'https://api.thegraph.com/index-node/graphql'

export const TC_MOBOX_SUBGRAPH = 'https://api.thegraph.com/subgraphs/name/pancakeswap/trading-competition-v3'
export const TC_MOD_SUBGRAPH = 'https://api.thegraph.com/subgraphs/name/pancakeswap/trading-competition-v4'

export const BIT_QUERY = 'https://graphql.bitquery.io'

export const ACCESS_RISK_API = '/api/risk'

export const CELER_API = 'https://api.celerscan.com/scan'

export const INFO_CLIENT_WITH_CHAIN = {
  [ChainId.FIRECHAIN]: INFO_CLIENT_FIRE,
  [ChainId.BSC]: INFO_CLIENT,
  [ChainId.ETHEREUM]: INFO_CLIENT_ETH,
  [ChainId.LINEA_TESTNET]: 'https://thegraph.goerli.zkevm.consensys.net/subgraphs/name/pancakeswap/exhange-eth/',
  [ChainId.ARBITRUM_ONE]: 'https://thegraph.com/hosted-service/subgraph/chef-jojo/exchange-v2-arb',  
  [ChainId.POLYGON]: INFO_CLIENT_MATIC,
  [ChainId.CRO]: INFO_CLIENT_CRO,
  [ChainId.AVALANCHE]: INFO_CLIENT_AVAX,
  [ChainId.FANTOM_OPERA]: INFO_CLIENT_FTM,
  [ChainId.CELO]: INFO_CLIENT_CELO,
  [ChainId.OPTIMISM]: INFO_CLIENT_OP_ETH,
  [ChainId.SHIBARIUM]: INFO_CLIENT_BONE,
  [ChainId.PULSECHAIN]: INFO_CLIENT_PLS,
  [ChainId.XEN]: INFO_CLIENT_XN,
  [ChainId.HARMONY]: INFO_CLIENT_ONE,
  [ChainId.COINEX]: INFO_CLIENT_CET,
  [ChainId.DOGECHAIN]: INFO_CLIENT_DOGE,
  [ChainId.ETHEREUM_CLASSIC]: INFO_CLIENT_ETC,
  [ChainId.FUSION]: INFO_CLIENT_FSN,
  [ChainId.HECO]: INFO_CLIENT_HECO,
  [ChainId.KCC]: INFO_CLIENT_KCS,
  [ChainId.KLAYTN]: INFO_CLIENT_KLAY,
  [ChainId.OKXCHAIN]: INFO_CLIENT_OKT,
  [ChainId.THETHA]: INFO_CLIENT_TFUEL,
  [ChainId.ULTRON]: INFO_CLIENT_ULX,
  [ChainId.MOONBEAM]: INFO_CLIENT_GLMR,
  [ChainId.MOONRIVER]: INFO_CLIENT_MOVR,
  [ChainId.AURORA]: INFO_CLIENT_AURORA_ETH,
  [ChainId.BOBA]: INFO_CLIENT_BOBA_ETH,
  [ChainId.GNOSIS]: INFO_CLIENT_XDAI,
  [ChainId.METIS]: INFO_CLIENT_METIS,
  [ChainId.TELOS]: INFO_CLIENT_TLOS,
  [ChainId.SYSCOIN]: INFO_CLIENT_SYS,
  [ChainId.IOTEX]: INFO_CLIENT_IOTX,
  [ChainId.SHIDEN]: INFO_CLIENT_SDN,
  [ChainId.ASTAR]: INFO_CLIENT_ASTR,
  [ChainId.FUSE]: INFO_CLIENT_FUSE,
  [ChainId.VELAS]: INFO_CLIENT_VLX,
  [ChainId.REI]: INFO_CLIENT_REI,
  [ChainId.KEKCHAIN]: INFO_CLIENT_KEK,
  [ChainId.TOMOCHAIN]: INFO_CLIENT_TOMO,
  [ChainId.THUNDERCORE]: INFO_CLIENT_TT,
  [ChainId.WANCHAIN]: INFO_CLIENT_WAN,
  [ChainId.RSK]: INFO_CLIENT_RBTC,
  [ChainId.ELASTOS]: INFO_CLIENT_ELA,
  [ChainId.CONFLUX]: INFO_CLIENT_CFX,
  [ChainId.BRISECHAIN]: INFO_CLIENT_BRISE,
  [ChainId.MUUCHAIN]: INFO_CLIENT_MUU,
  [ChainId.CANTO]: INFO_CLIENT_CANTO,
  [ChainId.OASIS_EMERALD]: INFO_CLIENT_ROSE,
  [ChainId.VISION]: INFO_CLIENT_VS,
  [ChainId.STEP]: INFO_CLIENT_STEP,
  [ChainId.METER]: INFO_CLIENT_MTR,
  [ChainId.GODWOKEN]: INFO_CLIENT_PCKB,
  [ChainId.CALLISTO]: INFO_CLIENT_CLO,
  [ChainId.EVMOS]: INFO_CLIENT_EVMOS,
  [ChainId.ENERGY_WEB_CHAIN]: INFO_CLIENT_EWT,
  [ChainId.BASE]: INFO_CLIENT_BASE_ETH,
  [ChainId.KAVA]: INFO_CLIENT_KAVA,
  [ChainId.CLOVER]: INFO_CLIENT_CLOVER,
  [ChainId.DEFICHAIN]: INFO_CLIENT_DEFICHAIN,
  [ChainId.BRONOS]: INFO_CLIENT_BRONOS,
  [ChainId.FILECOIN]: INFO_CLIENT_FILECOIN,
  [ChainId.FLARE]: INFO_CLIENT_FLARE,
  [ChainId.TARAXA]: INFO_CLIENT_TARAXA,
  [ChainId.ZKSYNC]: INFO_CLIENT_ZKSYNC,

  [ChainId.LINEA]: INFO_CLIENT_LINEA,
  [ChainId.BTTCHAIN]: INFO_CLIENT_BTTCHAIN,
  [ChainId.BOBA_AVAX]: INFO_CLIENT_BOBA_AVAX,
  [ChainId.BOBA_BNB]: INFO_CLIENT_BOBA_BNB,
  [ChainId.CMP]: INFO_CLIENT_CMP,
  [ChainId.CORE]: INFO_CLIENT_CORE,
  [ChainId.CUBECHAIN]: INFO_CLIENT_CUBECHAIN,
  [ChainId.DARWINIA_CRAB]: INFO_CLIENT_DARWINIA_CRAB,
  [ChainId.DIODE_PRETNET]: INFO_CLIENT_DIODE_PRETNET,
  [ChainId.GOCHAIN]: INFO_CLIENT_GOCHAIN,
  [ChainId.HAQQ]: INFO_CLIENT_HAQQ,
  [ChainId.KARDIACHAIN]: INFO_CLIENT_KARDIACHAIN,
  [ChainId.METADIUM]: INFO_CLIENT_METADIUM,
  [ChainId.PALM]: INFO_CLIENT_PALM,
  [ChainId.POLIS]: INFO_CLIENT_POLIS,
  [ChainId.SHIBACHAIN]: INFO_CLIENT_SHIBACHAIN,
  [ChainId.SMART_BCH]: INFO_CLIENT_SMART_BCH,
  [ChainId.SONGBIRD_CANARY]: INFO_CLIENT_SONGBIRD_CANARY,
  [ChainId.THAICHAIN]: INFO_CLIENT_THAICHAIN,
  [ChainId.UBIQ]: INFO_CLIENT_UBIQ,
  [ChainId.VECHAIN]: INFO_CLIENT_VECHAIN,
  [ChainId.XINFIN]: INFO_CLIENT_XINFIN,
  [ChainId.SCROLL]: INFO_CLIENT_SCROLL,
  [ChainId.ZYX]: INFO_CLIENT_ZYX,
}

export const BLOCKS_CLIENT_WITH_CHAIN = {
  [ChainId.FIRECHAIN]: BLOCKS_CLIENT_FIRE,
  [ChainId.BSC]: BLOCKS_CLIENT,
  [ChainId.ETHEREUM]: BLOCKS_CLIENT_ETH,
  [ChainId.POLYGON]: BLOCKS_CLIENT_MATIC,
  [ChainId.CRO]: BLOCKS_CLIENT_CRO,
  [ChainId.AVALANCHE]: BLOCKS_CLIENT_AVAX,
  [ChainId.FANTOM_OPERA]: BLOCKS_CLIENT_FTM,
  [ChainId.CELO]: BLOCKS_CLIENT_CELO,
  [ChainId.OPTIMISM]: BLOCKS_CLIENT_OP_ETH,
  [ChainId.SHIBARIUM]: BLOCKS_CLIENT_BONE,
  [ChainId.PULSECHAIN]: BLOCKS_CLIENT_PLS,
  [ChainId.XEN]: BLOCKS_CLIENT_XN,
  [ChainId.HARMONY]: BLOCKS_CLIENT_ONE,
  [ChainId.COINEX]: BLOCKS_CLIENT_CET,
  [ChainId.DOGECHAIN]: BLOCKS_CLIENT_DOGE,
  [ChainId.ETHEREUM_CLASSIC]: BLOCKS_CLIENT_ETC,
  [ChainId.FUSION]: BLOCKS_CLIENT_FSN,
  [ChainId.HECO]: BLOCKS_CLIENT_HECO,
  [ChainId.KCC]: BLOCKS_CLIENT_KCS,
  [ChainId.KLAYTN]: BLOCKS_CLIENT_KLAY,
  [ChainId.OKXCHAIN]: BLOCKS_CLIENT_OKT,
  [ChainId.THETHA]: BLOCKS_CLIENT_TFUEL,
  [ChainId.ULTRON]: BLOCKS_CLIENT_ULX,
  [ChainId.MOONBEAM]: BLOCKS_CLIENT_GLMR,
  [ChainId.MOONRIVER]: BLOCKS_CLIENT_MOVR,
  [ChainId.AURORA]: BLOCKS_CLIENT_AURORA_ETH,
  [ChainId.BOBA]: BLOCKS_CLIENT_BOBA_ETH,
  [ChainId.GNOSIS]: BLOCKS_CLIENT_XDAI,
  [ChainId.METIS]: BLOCKS_CLIENT_METIS,
  [ChainId.TELOS]: BLOCKS_CLIENT_TLOS,
  [ChainId.SYSCOIN]: BLOCKS_CLIENT_SYS,
  [ChainId.IOTEX]: BLOCKS_CLIENT_IOTX,
  [ChainId.SHIDEN]: BLOCKS_CLIENT_SDN,
  [ChainId.ASTAR]: BLOCKS_CLIENT_ASTR,
  [ChainId.FUSE]: BLOCKS_CLIENT_FUSE,
  [ChainId.VELAS]: BLOCKS_CLIENT_VLX,
  [ChainId.REI]: BLOCKS_CLIENT_REI,
  [ChainId.KEKCHAIN]: BLOCKS_CLIENT_KEK,
  [ChainId.TOMOCHAIN]: BLOCKS_CLIENT_TOMO,
  [ChainId.THUNDERCORE]: BLOCKS_CLIENT_TT,
  [ChainId.WANCHAIN]: BLOCKS_CLIENT_WAN,
  [ChainId.RSK]: BLOCKS_CLIENT_RBTC,
  [ChainId.ELASTOS]: BLOCKS_CLIENT_ELA,
  [ChainId.CONFLUX]: BLOCKS_CLIENT_CFX,
  [ChainId.BRISECHAIN]: BLOCKS_CLIENT_BRISE,
  [ChainId.MUUCHAIN]: BLOCKS_CLIENT_MUU,
  [ChainId.CANTO]: BLOCKS_CLIENT_CANTO,
  [ChainId.OASIS_EMERALD]: BLOCKS_CLIENT_ROSE,
  [ChainId.VISION]: BLOCKS_CLIENT_VS,
  [ChainId.STEP]: BLOCKS_CLIENT_STEP,
  [ChainId.METER]: BLOCKS_CLIENT_MTR,
  [ChainId.GODWOKEN]: BLOCKS_CLIENT_PCKB,
  [ChainId.CALLISTO]: BLOCKS_CLIENT_CLO,
  [ChainId.EVMOS]: BLOCKS_CLIENT_EVMOS,
  [ChainId.ENERGY_WEB_CHAIN]: BLOCKS_CLIENT_EWT,
  [ChainId.BASE]: BLOCKS_CLIENT_BASE_ETH,
  [ChainId.KAVA]: BLOCKS_CLIENT_KAVA,
  [ChainId.CLOVER]: BLOCKS_CLIENT_CLOVER,
  [ChainId.DEFICHAIN]: BLOCKS_CLIENT_DEFICHAIN,
  [ChainId.BRONOS]: BLOCKS_CLIENT_BRONOS,
  [ChainId.FILECOIN]: BLOCKS_CLIENT_FILECOIN,
  [ChainId.FLARE]: BLOCKS_CLIENT_FLARE,
  [ChainId.TARAXA]: BLOCKS_CLIENT_TARAXA,
  [ChainId.ZKSYNC]: BLOCKS_CLIENT_ZKSYNC,

  [ChainId.LINEA]: BLOCKS_CLIENT_LINEA,
  [ChainId.BTTCHAIN]: BLOCKS_CLIENT_BTTCHAIN,
  [ChainId.BOBA_AVAX]: BLOCKS_CLIENT_BOBA_AVAX,
  [ChainId.BOBA_BNB]: BLOCKS_CLIENT_BOBA_BNB,
  [ChainId.CMP]: BLOCKS_CLIENT_CMP,
  [ChainId.CORE]: BLOCKS_CLIENT_CORE,
  [ChainId.CUBECHAIN]: BLOCKS_CLIENT_CUBECHAIN,
  [ChainId.DARWINIA_CRAB]: BLOCKS_CLIENT_DARWINIA_CRAB,
  [ChainId.DIODE_PRETNET]: BLOCKS_CLIENT_DIODE_PRETNET,
  [ChainId.GOCHAIN]: BLOCKS_CLIENT_GOCHAIN,
  [ChainId.HAQQ]: BLOCKS_CLIENT_HAQQ,
  [ChainId.KARDIACHAIN]: BLOCKS_CLIENT_KARDIACHAIN,
  [ChainId.METADIUM]: BLOCKS_CLIENT_METADIUM,
  [ChainId.PALM]: BLOCKS_CLIENT_PALM,
  [ChainId.POLIS]: BLOCKS_CLIENT_POLIS,
  [ChainId.SHIBACHAIN]: BLOCKS_CLIENT_SHIBACHAIN,
  [ChainId.SMART_BCH]: BLOCKS_CLIENT_SMART_BCH,
  [ChainId.SONGBIRD_CANARY]: BLOCKS_CLIENT_SONGBIRD_CANARY,
  [ChainId.THAICHAIN]: BLOCKS_CLIENT_THAICHAIN,
  [ChainId.UBIQ]: BLOCKS_CLIENT_UBIQ,
  [ChainId.VECHAIN]: BLOCKS_CLIENT_VECHAIN,
  [ChainId.XINFIN]: BLOCKS_CLIENT_XINFIN,
  [ChainId.SCROLL]: BLOCKS_CLIENT_SCROLL,
  [ChainId.ZYX]: BLOCKS_CLIENT_ZYX,
}

export const ASSET_CDN = 'https://assets.donaswap.com'

export const V3_SUBGRAPH_URLS = {
  [ChainId.FIRECHAIN]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.RINIA]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.ETHEREUM]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3-eth',
  [ChainId.GOERLI]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3-goerli',
  [ChainId.SEPOLIA]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3-sepolia',
  [ChainId.BSC]: `https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3-bsc`,
  [ChainId.BSC_TESTNET]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3-chapel',
  [ChainId.POLYGON]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.POLYGON_MUMBAI]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.CRO]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.CRO_TESTNET]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.AVALANCHE]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.AVALANCHE_FUJI]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.FANTOM_OPERA]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.FANTOM_TESTNET]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.CELO]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.CELO_ALFAJORES]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.OPTIMISM]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.OPTIMISM_GOERLI]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.SHIBARIUM]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.SHIBARIUM_TESTNET]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.PULSECHAIN]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.PULSECHAIN_TESTNET]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.XEN]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.XEN_DEVNET]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.HARMONY]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.HARMONY_TESTNET]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.COINEX]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.COINEX_TESTNET]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.DOGECHAIN]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.DOGECHAIN_TESTNET]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.ETHEREUM_CLASSIC]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.ETHEREUM_CLASSIC_TESTNET]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.FUSION]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.FUSION_TESTNET]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.HECO]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.HECO_TESTNET]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.KCC]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.KCC_TESTNET]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.KLAYTN]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.KLAYTN_BAOBAB]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.OKXCHAIN]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.OKXCHAIN_TESTNET]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.THETHA]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.THETHA_TESTNET]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.ULTRON]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.ULTRON_TESTNET]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.MOONBEAM]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.MOONRIVER]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.MOONBASE_ALPHA]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.AURORA]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.AURORA_TESTNET]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.BOBA]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.BOBA_GOERLI]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.GNOSIS]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.GNOSIS_CHIADO]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.METIS]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.METIS_GOERLI]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.TELOS]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.TELOS_TESTNET]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.SYSCOIN]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.SYSCOIN_TANENBAUM]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.IOTEX]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.IOTEX_TESTNET]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.SHIDEN]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.ASTAR]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.SHIBUNYA]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.FUSE]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.FUSE_SPARKNET]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.VELAS]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.VELAS_TESTNET]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.REI]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.REI_TESTNET]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.KEKCHAIN]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.KEKCHAIN_TESTNET]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.TOMOCHAIN]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.TOMOCHAIN_TESTNET]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.THUNDERCORE]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.THUNDERCORE_TESTNET]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.WANCHAIN]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.WANCHAIN_TESTNET]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.RSK]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.RSK_TESTNET]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.ELASTOS]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.ELASTOS_TESTNET]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.CONFLUX]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.CONFLUX_TESTNET]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.BRISECHAIN]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.BRISECHAIN_TESTNET]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.MUUCHAIN]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.MUUCHAIN_TESTNET]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.CANTO]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.CANTO_TESTNET]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.OASIS_EMERALD]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.OASIS_TESTNET]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.VISION]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.VISION_TESTNET]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.STEP]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.STEP_TESTNET]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.METER]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.METER_TESTNET]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.GODWOKEN]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.GODWOKEN_TESTNET]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.CALLISTO]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.CALLISTO_TESTNET]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.EVMOS]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.EVMOS_TESTNET]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.ENERGY_WEB_CHAIN]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.ENERGY_VOLTA]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.BASE]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.BASE_GOERLI]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.KAVA]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.KAVA_TESTNET]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.CLOVER]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.CLOVER_TESTNET]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.DEFICHAIN]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.DEFICHAIN_TESTNET]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.BRONOS]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.BRONOS_TESTNET]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.FILECOIN]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.FILECOIN_CALIBRATION]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.FLARE]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.FLARE_TESTNET]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.TARAXA]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.TARAXA_TESTNET]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.ARBITRUM_ONE]: 'https://thegraph.com/hosted-service/subgraph/chef-jojo/exchange-v3-arb',
  [ChainId.ARBITRUM_GOERLI]: 'https://api.thegraph.com/subgraphs/name/chef-jojo/exhange-v3-arb-goerli',
  [ChainId.POLYGON_ZKEVM]: 'https://api.studio.thegraph.com/query/45376/exchange-v3-polygon-zkevm/v0.0.0',
  [ChainId.POLYGON_ZKEVM_TESTNET]: null,
  [ChainId.ZKSYNC]: null,
  [ChainId.ZKSYNC_TESTNET]: 'https://api.studio.thegraph.com/query/45376/exchange-v3-zksync-testnet/v0.0.1',
  [ChainId.LINEA]: 'https://thegraph.goerli.zkevm.consensys.net/subgraphs/name/pancakeswap/exchange-v3-linea-goerli',
  [ChainId.LINEA_TESTNET]: 'https://thegraph.goerli.zkevm.consensys.net/subgraphs/name/pancakeswap/exchange-v3-linea-goerli',

  [ChainId.BTTCHAIN]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.BTTCHAIN_TESTNET]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.BOBA_AVAX]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.BOBA_BNB]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.CMP]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.CMP_TESTNET]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.CORE]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.CORE_TESTNET]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.CUBECHAIN]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.CUBECHAIN_TESTNET]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.DARWINIA_CRAB]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.DARWINIA_PANGOLIN]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.DIODE_PRETNET]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.DIODE_TESTNET]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.GOCHAIN]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.GOCHAIN_TESTNET]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.HAQQ]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.HAQQ_TESTEDGE2]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.KARDIACHAIN]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.KARDIACHAIN_TESTNET]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.METADIUM]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.METADIUM_TESTNET]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.OP_BNB_TESTNET]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.PALM]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.PALM_TESTNET]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.POLIS]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.POLIS_TESTNET]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.SHIBACHAIN]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.SMART_BCH]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.SMART_BCH_TESTNET]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.SONGBIRD_CANARY]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.THAICHAIN]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.UBIQ]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.UBIQ_TESTNET]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.VECHAIN]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.VECHAIN_TESTNET]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.XINFIN]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.XINFIN_APOTHEM]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.SCROLL]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.SCROLL_SEPOLIA]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
  [ChainId.ZYX]: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3',
} satisfies Record<ChainId, string | null>

export const TRADING_REWARD_API = 'https://pancake-trading-fee-rebate-api.pancakeswap.com/api/v1'

export const QUOTING_API = `${process.env.NEXT_PUBLIC_QUOTING_API}/v0/quote`

export const FARMS_API = 'https://farms-api.pancakeswap.com'

export const MERCURYO_WIDGET_ID = process.env.NEXT_PUBLIC_MERCURYO_WIDGET_ID || '95a003f2-354a-4396-828a-1126d56e4e13'
